import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const initialState = () => ({
    ibge: {
      estados: [{"id":11,"sigla":"RO","nome":"Rondônia","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":12,"sigla":"AC","nome":"Acre","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":13,"sigla":"AM","nome":"Amazonas","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":14,"sigla":"RR","nome":"Roraima","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":15,"sigla":"PA","nome":"Pará","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":16,"sigla":"AP","nome":"Amapá","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":17,"sigla":"TO","nome":"Tocantins","regiao":{"id":1,"sigla":"N","nome":"Norte"}},{"id":21,"sigla":"MA","nome":"Maranhão","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":22,"sigla":"PI","nome":"Piauí","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":23,"sigla":"CE","nome":"Ceará","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":24,"sigla":"RN","nome":"Rio Grande do Norte","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":25,"sigla":"PB","nome":"Paraíba","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":26,"sigla":"PE","nome":"Pernambuco","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":27,"sigla":"AL","nome":"Alagoas","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":28,"sigla":"SE","nome":"Sergipe","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":29,"sigla":"BA","nome":"Bahia","regiao":{"id":2,"sigla":"NE","nome":"Nordeste"}},{"id":31,"sigla":"MG","nome":"Minas Gerais","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":32,"sigla":"ES","nome":"Espírito Santo","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":33,"sigla":"RJ","nome":"Rio de Janeiro","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":35,"sigla":"SP","nome":"São Paulo","regiao":{"id":3,"sigla":"SE","nome":"Sudeste"}},{"id":41,"sigla":"PR","nome":"Paraná","regiao":{"id":4,"sigla":"S","nome":"Sul"}},{"id":42,"sigla":"SC","nome":"Santa Catarina","regiao":{"id":4,"sigla":"S","nome":"Sul"}},{"id":43,"sigla":"RS","nome":"Rio Grande do Sul","regiao":{"id":4,"sigla":"S","nome":"Sul"}},{"id":50,"sigla":"MS","nome":"Mato Grosso do Sul","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}},{"id":51,"sigla":"MT","nome":"Mato Grosso","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}},{"id":52,"sigla":"GO","nome":"Goiás","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}},{"id":53,"sigla":"DF","nome":"Distrito Federal","regiao":{"id":5,"sigla":"CO","nome":"Centro-Oeste"}}]
    },
    statusDescription: {
      'CANCELLED': 'Cancelada pelo PagSeguro',
      'CANCELLED_BY_RECEIVER': 'Cancelada pelo vendedor',
      'CANCELLED_BY_SENDER': 'Cancelada pelo comprador',
      'EXPIRED': 'Assinatura expirada',
      'SUSPENDED': 'Assinatura suspensa',
      'PAYMENT_METHOD_CHANGE': 'Cartão expirado, cancelado ou bloqueado. É preciso substituir.',
      'ACTIVE': 'Ativa',
      'PENDING': 'Pendente',
      'INITIATED': 'Processo iniciado, mas abandonado',
    },
    sideMenuItems: [
      {
        title: 'Usuários',
        levels: ['admin'],
        children: [
          {
            title: 'Novo usuário',
            to: '/dashboard/usuarios/novo-usuario',
          },

          {
            title: 'Editar usuários',
            to: '/dashboard/usuarios/editar-usuario'
          }
        ]
      },
      {
        title: 'Planos',
        levels: ['admin'],
        icon: 'fa fa-money',
        children: [
          {
            title: 'Editar planos',
            to: '/dashboard/planos/editar-plano'
          }
        ]
      },
      {
        title: 'Pickers',
        levels: ['supermarket'],
        children: [
          {
            title: 'Novo picker',
            to: '/dashboard/usuarios/novo-picker',
          },

          {
            title: 'Editar picker',
            to: '/dashboard/usuarios/editar-picker'
          }
        ]
      },
      {
        title: 'Supermercados',
        levels: ['admin'],
        children: [
          // {
          //   title: 'Novo supermercado',
          //   to: '/admin/supermercados/novo-supermercado',
          // },

          {
            title: 'Lista de supermercados',
            to: '/dashboard/supermercados/listagem',
          },

          // {
          //   title: 'Nova rede',
          //   to: '/dashboard/supermercados/nova-rede'
          // },

          // {
          //   title: 'Lista de redes',
          //   to: '/dashboard/supermercados/redes'
          // }
        ]
      },
      {
        title: 'Picking',
        to: '/dashboard/picking',
        levels: ['supermarket', 'picker'],
        icon: 'fa fa-check-square o'
      },
      {
        title: 'Relatórios',
        levels: ['admin', 'supermarket'],
        icon: 'fa fa-line-chart',
        children: [
          {
            title: 'Clientes',
            to: '/dashboard/relatorios/clientes',
          },
          {
            title: 'Vendas',
            to: '/dashboard/relatorios/vendas',
          },
          {
            title: 'Produtos Vendidos',
            to: '/dashboard/relatorios/produtos-vendidos',
          },
          {
            title: 'Supermercados',
            to: '/dashboard/relatorios/supermercados',
          }
        ]
      }
    ],
    userData: {},
    userType: {
      'admin': 'Admin',
      'supermarket': 'Supermercado',
      'picker': 'Picker'
    },
    authUser: null,
    selectedPlan: 'STANDARD',
    plans: {
      'BASIC': {
        code: '909A160ED3D37C0224F4AF8DE1552A6C',
        amount: 39.99
      },
      'STANDARD': {
        code: '6063F21F7E7E09FBB4345FB30DCD1152',
        amount: 69.99
      },
      'UNLIMITED': {
        code: '2743C23FC5C598A55461EF905F3C1282',
        amount: 99.99
      },
    }
});

const actions = {
  resetState({ commit }) {
    commit('resetState');
  }
};

export default new Vuex.Store({
  state: initialState(),
  getters: {
    plans: state => state.plans,
    currentPlan: state => state.selectedPlan,
    userData: state => state.userData,
    authUser: state => state.authUser,
    userType: state => state.userType,
    sideMenuItems: state => state.sideMenuItems,
    fetchPagseguroStatus: state => state.statusDescription,
    ibge: state => state.ibge
  },  
  mutations: {
    resetState(state) {
      Object.assign(state, initialState)
    },
    setCurrentPlan(state, plan) {
      state.selectedPlan = plan;
    },
    setUserData(state, user) {
      state.userData = Object.assign( {...state.userData}, user );
    },
    setAuthUser(state, user) {
      console.log('setando usuário');
      state.authUser = user;
    }
  },
  actions,
  modules: {
  }
});
